<template>
  <div class="animated fadeIn">
    <div class="page-card-margin row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.maximeter_analysis}}</strong>
          </div>
          <div class="card-block">
            <div class="form-group row">
              <div class="col-lg-5 form-group">
                <label>{{web_texts.date_range}}</label>
                <div class="input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12">
                  <span class="add-on input-group-addon"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i></span>
                  <input type="text" name="daterange" id="daterange" class="form-control input-lg"/>
                </div>
              </div>
              <div class="col-lg-7 form-group">
                <input type="checkbox" v-model="checked">
                <label for="checkbox">{{web_texts.all_devices}}</label>
                <hr style="margin-top: 0px">
                <div class="row">
                  <span v-for="check_box in check_boxes" class="col-xlg-5 col-md-5 col-sm-5 col-xs-5" style="margin-top: -10px; margin-right:10px">
                    <input v-if="check_box.name!=='Irrimation' && check_box.type!=='CVMNET4' && check_box.type!=='LM4A'" type="checkbox" id="checkbox" @click="checkValue(check_box.id)">
                    <label v-if="check_box.name!=='Irrimation' && check_box.type!=='CVMNET4' && check_box.type!=='LM4A'" for="checkbox">{{check_box.name}}</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: -20px">
              <div class="col-lg-12">
                <hr style="margin-top: 0px">
                <button class="btn btn-primary btn-sm" @click="selectTableOrGraphAndBuildRequest('graph')" :disabled="isButtonDisabled"><i class="fa fa-line-chart"></i>{{web_texts.graph}}</button>
                <button class="btn btn-primary btn-sm" @click="selectTableOrGraphAndBuildRequest('table')" :disabled="isButtonDisabled"><i class="fa fa-table"></i>{{web_texts.table}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GeneralSpinner v-if="to_show==='spinner'"></GeneralSpinner>
    <div class="row" v-else-if="to_show==='table'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.max_historical}}</strong>
          </div>
          <div class="card-block">
            <vue-good-table :columns="columns" :rows="table_data_power" :paginate="true" :perPage="5">
              <template slot="table-row" scope="props">
                <td>{{props.row.dateTime}}</td>
                <td v-if="multiple_values" v-for="lectures in props.row.field">{{Math.round(lectures.value*100)/100}} kW</td>
                <td v-if="!multiple_values">{{Math.round(props.row.field.value*100)/100}} kW</td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="to_show==='graph'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.max_historical}}</strong>
          </div>
          <div class="card-block">
            <div id="chartContainer" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Maximeter';
  import trans_es from '../translates/es/Maximeter';
  import constants from '../constants';
  import middleware from '../utilities/middlewares';
  import dataTransforms from '../utilities/data_transformers';
  import dates_intervals from '../utilities/dates_intervals'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: '',
    data() {
      return {
        web_texts: { "maximeter_analysis": "Anàlisi de maxímetre", "date_range": "Rang de dates", "all_devices": "Tots els dispositius", "graph": "Gràfic", "table": "Taula", "max_historical": "Històric Maxímetre" },
        devices: '',
        device: '',
        check_boxes: [],
        checked: '',
        table_data_power: [],
        isButtonDisabled: false,
        months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
        captions: {'ok_button': 'Seleccionar'},
        shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
        columns: [],
        multiple_values: true,
        to_show:''
      }
    },
    components:{
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      window.localStorage.setItem('real_time_control', '["maximeter","maximeter"]');

      this.system = JSON.parse(localStorage.getItem('system'));
      // inicialitzem los checkboxes
      this.initializeCheckBox();
    },
    mounted(){
      // inicialitzem daterangepicker
      this.initializeDateRangePicker();
    },
    methods: {
      // Funcio que demana el dispositiu i busca les dades per a crear el checkbox
      initializeCheckBox() {
        axios.post(constants.ROOT_URL + '/api/v1/get_devices', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.devices = response.data;
          for(var i=0; i<this.devices.length; i++){
            if(this.devices[i].type==="CVMNET4"){
              var channel=JSON.parse(this.devices[i].channels);
              for(var c=0; c<channel.length;c++){
                this.devices.push(channel[c])
              }
            }
          }

          var obj = null;
          for (var i = 0; i < this.devices.length; i++) {
            if(this.devices[i].hasOwnProperty('ch')){
              obj = {
                [this.devices[i].id+"_"+this.devices[i].ch]: 0,
                id: this.devices[i].id+"_"+this.devices[i].ch,
                type: this.devices[i].type,
                name: this.devices[i].name,
                ch: this.devices[i].ch
              };
            }else{
              obj = {
                [this.devices[i].id+"_0"]: 0,
                id: this.devices[i].id+"_0",
                type: this.devices[i].type,
                name: this.devices[i].name
              };
            }
            this.check_boxes.push(obj)
          }
        }, (response) => {
          console.log(response.data);
        });
      },
      // Funcio que aplica el valor 1 o 0 al les dades del checkbox depenent de si esta seleccionat o no
      checkValue(device_id) {
        console.log(device_id);
        for (var i = 0; i < this.check_boxes.length; i++) {
          if (typeof this.check_boxes[i][device_id] !== "undefined" && this.check_boxes[i][device_id] === 0) {
            this.check_boxes[i][device_id] = 1
          } else if (typeof this.check_boxes[i][device_id] !== "undefined" && this.check_boxes[i][device_id] === 1) {
            this.check_boxes[i][device_id] = 0
          }
        }
        console.log(JSON.stringify(this.check_boxes))
      },
      // funcio que agafa checkboxes seleccionats i envia les dades al graf o la taula
      selectTableOrGraphAndBuildRequest(graph_or_table) {
        var to_show_internal = [];
        var req_par = [];
        this.to_show='spinner';
        this.isButtonDisabled=true;

        console.log(this.check_boxes);

        // Bucle checkboxes
        for (var i = 0; i < this.check_boxes.length; i++) {
          // si esta l'opcio de totes les checkboxes o la checkbox determinada seleccionada entrar
          if ((this.checked === true) || (this.check_boxes[i][Object.keys(this.check_boxes[i])[0]] !== 0)) {
            if(this.check_boxes[i].hasOwnProperty('ch')){
              req_par.push([(Object.keys(this.check_boxes[i])[0].split('_'))[0], "MDC"+this.check_boxes[i].ch+"I"]);
              to_show_internal.push(this.check_boxes[i]);
            }else{
              req_par.push([(Object.keys(this.check_boxes[i])[0].split('_'))[0], "MDAPI", "MDI"]);
              to_show_internal.push(this.check_boxes[i]);
            }
          }
        }

        // Si es graph o taula entra a la funcio corresponent
        if ('graph' === graph_or_table) {
          this.getGraphArrayPower(req_par, to_show_internal)
        } else if ('table' === graph_or_table) {
          this.getTableArrayPower(req_par, to_show_internal);
        }
      },
      // Funcio que agafa els valors per a imprimir la taula
      getTableArrayPower(req_par, to_show_internal) {
        // La funcio headerTable es la que printa els tituls a la taula
        this.headerTable(req_par, to_show_internal);
        // agafem els valors per a implimir la taula
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify(req_par),
          date_range: document.getElementById('daterange').value
        }).then((response) => {
          this.to_show='table';
          this.isButtonDisabled=false;
          this.formatTableDate(response.data);
        }, (response) => {
          this.isButtonDisabled=false;
          console.log(response.data);
        });
      },
      // funcio printa els tituls a la taula
      headerTable(req_par, to_show_internal) {
        if (req_par.length > 1) {
          this.multiple_values = true;
        } else {
          this.multiple_values = false;
        }

        console.log(to_show_internal)

        var header_make = '[{"label": "Data i hora"}';
        for (var i = 0; i < to_show_internal.length; i++) {
          header_make += ', {"label": "' + to_show_internal[i].name + '"}';
        }
        header_make += ']';
        this.columns = JSON.parse(header_make);
      },
      // Funcio que agafa els valors per a mostrar al graf
      getGraphArrayPower(req_par, to_show_internal) {
        console.log(req_par);
        // agafem els valors per a implimir la taula
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          vars: JSON.stringify(req_par),
          client_device: 'd',
          date_range: document.getElementById('daterange').value
        }).then((response) => {
          var data_resp=response.data;
          var out=this;
          this.to_show='graph';
          this.isButtonDisabled=false;
          var arr_before_req=req_par;

          setTimeout(function () {
            out.printGraph(dataTransforms.lineDataTransformCanvasJS(data_resp, "line", out.transformIdToName(to_show_internal)));
          },25);

        }, (response) => {
          this.isButtonDisabled=false;
          console.log(response.data);
        });
      },
      // Funcio que imprimeix el grafic
      printGraph(data){
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX:{
            valueFormatString: "DD/MM HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data  // random data
        };

        $("#chartContainer").CanvasJSChart(options);
      },
      // Funcio que et fa un array en los noms dels dispositius seleccionats per al graf
      transformIdToName(arr_before_req){
        var response=[];

        for(var i=0; i<arr_before_req.length; i++){
          response.push(arr_before_req[i].name);
        }
        return response;
      },
      // Funcio que imprimeix la taula
      formatTableDate(array_date){
        for(var i=0; i<array_date.length;i++){
          array_date[i].dateTime = dates_intervals.correctDateTimeAPI(dates_intervals.transformDateResponse(array_date[i].dateTime));
        }
        this.table_data_power = array_date;
      },
      // Funcio per a que funcione el datepicker
      initializeDateRangePicker(){
        $(function() {
          var date = new Date();
          var month = date.getMonth();
          var year = date.getFullYear();
          $('input[name="daterange"]').daterangepicker({
            "locale": {
              "format": "DD/MM/YYYY",
              "separator": " - ",
              "applyLabel": "Acceptar",
              "cancelLabel": "Cancel·lar",
              "fromLabel": "Des de",
              "toLabel": "Fins",
              "customRangeLabel": "Custom",
              "weekLabel": "W",
              "daysOfWeek": [
                "dg",
                "dl",
                "dt",
                "dc",
                "dj",
                "dv",
                "ds"
              ],
              "monthNames": [
                "Gener",
                "Febrer",
                "Març",
                "Abril",
                "Maig",
                "Juny",
                "Juliol ",
                "Agost ",
                "Setembre",
                "Octubre",
                "Novembre",
                "Desembre"
              ],
              "firstDay": 1
            },
            "startDate": "1/"+(month+1)+"/"+year,
            "endDate": "28/"+(month+1)+"/"+year
          })
        });
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Maximeter.vue?863cd8fc